module.exports = __webpack_public_path__ + "img/moldavia.888593e1.svg";